import React from 'react'
import { Trans, t } from '@lingui/macro'
import Link from 'next/link'
import { _ } from '../../utils/intl'
import { Grid, GridCol } from '../../ui-kit'
import { ContactLinksList } from '../contact/ContactLinksList'
import { clientStore } from '../../../client/ClientStore'
import { PRODUCT } from '../../../config/constants'
import { getFaqsPageHref } from '../contact/GetFaqsPageHref'

export const ContactHelp: React.FC = () => {
  const getFaqsLink = () => {
    switch (clientStore.activeProduct) {
      case PRODUCT.DEJEUNER:
        return `${getFaqsPageHref()}/?theme=9`

      case PRODUCT.SHELL:
        return `${getFaqsPageHref()}/?theme=11`

      default:
        return getFaqsPageHref()
    }
  }

  return (
    <Grid>
      <GridCol>
        <Grid gutters="condensed">
          <GridCol size="fixed">
            <img src="/static/illustrations/infoline.svg" alt={_(t`Support`)} />
          </GridCol>
          <GridCol size="auto">
            <div className="text-bold">
              <Trans>Zákaznícka podpora</Trans>
            </div>
            <div>
              <ContactLinksList emailFirst light productCode={clientStore.activeProduct} />
            </div>
            <div className="text-small text-color-grey-300">
              <Trans>v pracovných dňoch 8:00-16:30</Trans>
            </div>
            <div>
              <Link href={getFaqsLink()}>
                <a className="btn btn--tiny btn--condensed btn--link mb-none pl-none">
                  <Trans>Najčastejšie otázky</Trans>
                </a>
              </Link>
            </div>
          </GridCol>
        </Grid>
      </GridCol>
    </Grid>
  )
}
